import React, { Component } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import styles from "../dealerDashBoard/DashboardStyles.module.scss";
import dashboardStyles from "../dealerDashBoard/dashboardStyles";
import Clear from "@material-ui/icons/Clear";
import { withTranslation } from "react-i18next";
import UpperCaseText from "../../../utils/UpperCaseText";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";
import NavigateBefore from "@material-ui/icons/NavigateBefore";
import crStyles from "../../customerReservation/crStyles";
import NavigateNext from "@material-ui/icons/NavigateNext";
import NscNotificationsClient from "../../../shared/clients/NscNotificationsClient";

function formatDealerCode(venderId) {
  const pattern = /^[^|]*\|(.+?)\|[^|]*$/;
  const replaced =
    venderId &&
    venderId.replace(pattern, (match, captured) => captured.replace(/\|/g, ""));
  return replaced;
}

class NscOrderAcceptanceNotifications extends Component {
  constructor(props) {
    super(props);
    this.state = {
      notifications: [],
      renderApp: false,
      totalCount: 0,
      totalPages: 0,
      currentPage: 0,
      hasNext: false,
      hasPrevious: false,
    };
    this.hasError = false;

    this.herculesCanViewDealerType =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "herculesCanViewDealerType"
      );
  }

  componentDidMount() {
    this.props.hideOrShow(true, true);
    this.getNscOrderAcceptanceNotifications();
  }

  handlePrevious = () => {
    NscNotificationsClient.getNscOrderAcceptanceNotifications(
      this.props.user,
      this.state.currentPage - 1,
      this.props.selectedMarket
    )
      .then((data) => {
        this.populateState(data);
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  handleNext = () => {
    NscNotificationsClient.getNscOrderAcceptanceNotifications(
      this.props.user,
      this.state.currentPage + 1,
      this.props.selectedMarket
    )
      .then((data) => {
        this.populateState(data);
      })
      .catch()
      .finally(() => {
        this.props.hideOrShow(false);
      });
  };

  getNscOrderAcceptanceNotifications = () => {
    NscNotificationsClient.getNscOrderAcceptanceNotifications(
      this.props.user,
      this.state.currentPage,
      this.props.selectedMarket
    )
      .then((data) => {
        this.populateState(data);
      })
      .catch(() => {
        this.hasError = true;
      })
      .finally(() => {
        this.props.hideOrShow(false);
        this.setState({ renderApp: true });
      });
  };

  populateState = (data) => {
    if (data !== null) {
      this.setState({
        notifications: data.ordersData,
        totalCount: data.pagination.totalCount,
        totalPages: data.pagination.totalPages,
        currentPage: data.pagination.page,
        hasNext: data.pagination.hasNext,
        hasPrevious: data.pagination.hasPrevious,
      });
    }
  };

  deleteNotification = (id) => {
    NscNotificationsClient.deleteNotification(
      this.props.user,
      this.props.selectedMarket,
      id
    ).then(() => {
      this.setState((prevState) => ({
        notifications: this.state.notifications.filter(
          (notification) => notification.uid !== id
        ),
        totalCount: prevState.totalCount - 1,
      }));
    });
  };

  render() {
    const onPage =
      this.state.notifications.length > 0 ? this.state.currentPage + 1 : 0;

    function getTableHeader(style, divStyle, column) {
      return (
        <TableCell id={column + column} style={style}>
          <div className={divStyle}>
            {this.props.t("OrdersDashboard." + column)}
          </div>
        </TableCell>
      );
    }

    let orders = [];
    if (this.state.notifications.length > 0) {
      orders = this.state.notifications;
    }

    const fromPoNscSearch =
      this.props.userDetails && this.props.userDetails.fromPoNscSearch;

    return (
      this.state.renderApp &&
      (this.hasError ? (
        <div
          style={dashboardStyles.header}
          className={styles.notificationHeader}
        >
          {this.props.t("DealerDashboard.outStandingOrdersHeader")}
          <h2>{this.props.t("InvalidRoute.header")}</h2>
        </div>
      ) : (
        <div>
          <div
            style={dashboardStyles.header}
            className={styles.notificationHeader}
          >
            {this.props.t("DealerDashboard.outStandingOrdersHeader")} (
            <span data-testid="allNotificationCount">
              {this.state.totalCount}
            </span>
            )
          </div>
          <Table data-testid="notificationsTable" key="dealerDashBoardTable">
            <TableHead>
              <TableRow
                style={dashboardStyles.dashboardHeader}
                className={styles.tableHeaderLine}
              >
                {getTableHeader.call(
                  this,
                  dashboardStyles.typeHeader,
                  styles.alignStart,
                  "type",
                  0
                )}
                {getTableHeader.call(
                  this,
                  dashboardStyles.orderIdHeader,
                  styles.alignStart,
                  "description",
                  1
                )}
                {getTableHeader.call(
                  this,
                  dashboardStyles.dateHeader,
                  styles.alignStart,
                  "pendingDueDate",
                  2
                )}
                <TableCell style={dashboardStyles.emptyHeader} />
              </TableRow>
            </TableHead>

            <TableBody>
              {orders.map((notification, index) => (
                <TableRow
                  className={
                    notification.siteMessageStatus === "READ"
                      ? styles.textContentBodyListRead
                      : styles.textContentBodyListNew
                  }
                  id={"row" + index}
                  key={index}
                >
                  <TableCell style={dashboardStyles.leftCell}>
                    <ReportProblemOutlinedIcon
                      data-testid={`problemIcon-${notification.params.reservationId}`}
                      className={styles.actionIconOrders}
                    />
                    {`${UpperCaseText(notification.type)} - #${
                      notification.params.reservationId
                    } - ${formatDealerCode(notification.vendorId)}`}
                  </TableCell>
                  <TableCell style={dashboardStyles.centerCell}>
                    {notification.params.NotificationMsg}
                  </TableCell>
                  <TableCell
                    className={styles.col3}
                    style={dashboardStyles.centerCell}
                  >
                    {this.props.t("CustomerOrderDetails.actionRequired")}
                  </TableCell>

                  {fromPoNscSearch ? (
                    <TableCell
                      data-testid={`deleteNotification${index}`}
                      style={dashboardStyles.rightCell}
                    ></TableCell>
                  ) : (
                    <TableCell
                      data-testid={`deleteNotification${index}`}
                      style={dashboardStyles.rightCell}
                      className={styles.cursorButton}
                      onClick={() => this.deleteNotification(notification.uid)}
                    >
                      <div className={styles.closeButton}>
                        <Clear />
                      </div>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <div className={styles.pagesDiv}>
            <button
              disabled={this.state.hasPrevious === false}
              data-testid="prev"
              onClick={() => this.handlePrevious()}
              className={styles.buttonStyle}
            >
              <NavigateBefore
                style={
                  this.state.hasPrevious === false
                    ? crStyles.arrowDisabled
                    : crStyles.arrowEnabled
                }
              />
            </button>
            <div className={styles.pages}>
              {onPage} / {this.state.totalPages}
            </div>
            <button
              disabled={this.state.hasNext === false}
              data-testid="next"
              onClick={() => this.handleNext()}
              className={styles.buttonStyle}
            >
              <NavigateNext
                style={
                  this.state.hasNext === false
                    ? crStyles.arrowDisabled
                    : crStyles.arrowEnabled
                }
              />
            </button>
          </div>
        </div>
      ))
    );
  }
}

export default withTranslation("emp")(NscOrderAcceptanceNotifications);
